import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-28915cb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex fl-jc-sb flex-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Фильтры", -1))
const _hoisted_3 = { class: "flex flex-col fl-1 fl-jc-end" }
const _hoisted_4 = { class: "flex m-t-10" }

import { ref, computed, watch } from "vue";

import Button from "primevue/button";

import { deepEqual } from "@/services/utils/Objects";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilterForm',
  props: {
    isFilterEnabled: { type: Boolean },
    initialFilter: {},
    hasLocal: { type: Boolean },
    baseFilter: {}
  },
  emits: ["toggleFilter", "setFilter", "updateLocalFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const filter = props.baseFilter
  ? ref(JSON.parse(JSON.stringify(props.baseFilter)))
  : ref(JSON.parse(JSON.stringify(props.initialFilter)));

const isFilterChanged = computed(() => {
  return !deepEqual(filter.value, props.initialFilter);
});

const cancelChanges = () => {
  filter.value = props.baseFilter
    ? { ...props.baseFilter }
    : { ...props.initialFilter };
  emit("setFilter", filter.value, false);
};

const setFilter = () => {
  emit("toggleFilter");
  emit("setFilter", filter.value, true);
};

watch(
  () => props.isFilterEnabled,
  (newValue) => {
    if (newValue) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
  }
);

watch(
  () => props.baseFilter,
  (newBaseFilter) => {
    try {
      if (newBaseFilter != undefined)
        filter.value = JSON.parse(JSON.stringify(newBaseFilter));
    } catch (e) {
      console.error("Ошибка декодирования фильтра:", newBaseFilter);
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => filter.value,
  (newValue) => {
    if (props.hasLocal) {
      emit("updateLocalFilter", newValue);
    }
  },
  { deep: true }
);

function handleClickOutside(event: any) {
  if (event.target.id == "top-hide-element") {
    emit("toggleFilter");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["top", [_ctx.isFilterEnabled ? 'active' : '']]),
      id: "top-hide-element"
    }, null, 2),
    _createElementVNode("div", {
      id: "segments-filter-form",
      class: _normalizeClass(["segments-filter-form scrollbar-custom", [_ctx.isFilterEnabled ? 'active' : '']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(Button), {
          icon: "pi pi-times",
          severity: "secondary",
          text: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggleFilter'))),
          rounded: ""
        })
      ]),
      _renderSlot(_ctx.$slots, "fields", { filter: _unref(filter) }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Button), {
            label: "Применить",
            severity: "secondary",
            class: "m-r-12 fl-1",
            onClick: setFilter,
            disabled: !isFilterChanged.value
          }, null, 8, ["disabled"]),
          _createVNode(_unref(Button), {
            label: "Сбросить всё",
            severity: "secondary",
            class: "fl-1",
            onClick: cancelChanges
          })
        ])
      ])
    ], 2)
  ], 64))
}
}

})